/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState} from 'react'
import S3UploadHook from '../../CommonMethods/S3UploadHook'
import ErrorMessage from '../ErrorMessage'
import ToolTip from '../ToolTip'
import UploadProgress from '../UploadProgress'
import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement'
import { downloadS3Object } from '../../CommonMethods/S3DownloadHook'

export default function FileUploadIcon({
    state,
    fileId,
    formatError,
    setstate,
    setformatError,
    setimageLoading,
    imageLoading,
    placeholder,
    classKey,
    keyName,
    submitSelected,
    optional,
    text,
    mainKey
}) {
    const imageTypes=['image/png','image/jpeg','image/jpg','application/pdf']
    const [progressCount, setprogressCount] = useState(0)
    //Upload file
    async function handleUploadChange(e) {
        // setformatError('')
        const path =`${mainKey}/${e.target.id}`
        const selectedFile = e.target.files[0];
        // setimageLoading(e.target.id)
        if (e.target.files) {
            if(!imageTypes.includes(e.target.files[0].type )|| (selectedFile && selectedFile.size > 10 * 1024 * 1024) ){
                // setOpen('')
                // const errorElement = pushOrRemoveElement(formatError, e.target.id)
                setformatError(e.target.id);
                // setimageLoading('')

                // return

            }else{
                // setloading('upload')
                const file = e.target.files[0];
                const fileLink = URL.createObjectURL(file);   
                let url=''
                if(file.name && file.type){
                    url= await S3UploadHook(file,`${mainKey}/${fileId}`,setprogressCount); 

                    // const val =`${mainKey}/${id}/${file.name}`

                    setstate((prv)=>({
                        ...prv,
                        [fileId]:url
                    }))
                    // setimageLoading('')

                    return                    
                    // handleSubmit(file,fileLink)
                } 
            }
            
        }
        
    }
    //remove file
    const handleRemove =(fileId)=>{
        setstate((prv)=>({
            ...prv,
            [fileId]:''
        }))
    }
    const handelDownload = async(val) => {
        downloadS3Object(val)
        //setToastmessage("File downloaded successfully")
    }
    return (
        
        
        <div className="flex flex-col relative">
            {/*<ToolTip name={`Upload ${keyName}`}/> */}
            <div className="relative">
                {state[fileId] === ''?
                    <div class="group border border-[#106EB4] rounded w-[30px] h-[30px] uploadFileBtn ml-1 flex justify-center items-center relative">
                        <img src="/images/upload-cloud.svg" alt="img" class="cursor-pointer"/>
                        <label for="upload_img"></label>
                        <input 
                            id={fileId} 
                            type="file" 
                            accept=".png,.jpg,.jpeg,.gif, .pdf"
                            title=''
                            data-allowed-file-extensions="png,jpg,jpeg,gif,pdf" 
                            class="opacity-0 absolute top-0 left-0 text-[0px] w-[30px] h-[30px] cursor-pointer z-10"
                            onChange={(e)=>handleUploadChange(e)}
                        />
                        <span class="absolute top-10 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Upload</span>
                    </div>
                    :
                    <div class="flex uploaded_file ml-1">
                        <div className='group relative'>
                            <button 
                                onClick={() => handelDownload(state[fileId])}
                                type="button" 
                                class="border border-[#106EB4] rounded p-1 downloadAdhar relative"
                            >
                                <img src="/images/download-view-file.svg" alt="img"/>
                                <span class="absolute top-9 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Download</span>
                            </button> 
                        </div>
                        <div className='group relative'>
                            <button 
                                type="button" 
                                class="group border border-[#106EB4] rounded p-1 ml-2 relative"
                                onClick={() => handleRemove(fileId)}
                            >
                                <img src="/images/file-remove.svg" alt="img"/>
                                <span class="absolute top-9 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Remove</span>
                            </button>
                        </div>
                    </div>

                }
            </div>
            {/*{!submitSelected && formatError ===fileId  && 
                <ErrorMessage error 
                    message="The uploaded file does not meet the required file format or size. Please try again" 
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5" />}
            {(submitSelected&& state[fileId] === '' &&optional===undefined)&&
                <ErrorMessage
                    message={text}
                    error
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5"

            />}  */}
        </div>
    )
}
